export const FEATURE_FLAG_SEARCH_IN_SPACE_DEVELOPMENT = 'search-in-space-alpha';

export const FEATURE_FLAG_SEARCH_IN_SPACE_EARLY_ACCESS = 'search-in-space-early-access';
